import { fork, takeEvery } from 'redux-saga/effects';
import userDuck from '../ducks/user';
import layoutDuck from '../ducks/layouts';
import changesetDuck from '../ducks/changesets';
import projectDuck from '../ducks/project';
import addPhoto from '../ducks/addPhotos/addPhotos';
import { IMAGES_TO_UPLOAD } from '../ducks/addPhotos/imagesToUpload';
import uploadImages from '../utils/uploadImageService';
import selectionDuck from '../ducks/selection';
import sectionDuck from '../ducks/sections';
import wrapDuck from '../ducks/wrap';
import navigationDuck from '../ducks/navigation';
import preloaderDuck from '../ducks/preloader';
import loadedImages from '../ducks/loadedImages';
import messages from '../ducks/messages';
import initDuck from '../ducks/init';
import pricing from '../ducks/pricing';
import marketingBannerDuck from '../ducks/marketingBanner';
import appSyncSaga from './appSyncSaga';

//noinspection JSUnusedGlobalSymbols
export default function* rootSaga() {
  // // // getting sleepy so we can use the debugger
  // yield delay(3000);

  yield fork(initDuck.saga);
  yield fork(userDuck.saga);
  yield fork(layoutDuck.saga);
  yield fork(changesetDuck.saga);
  yield fork(wrapDuck.saga);
  yield fork(projectDuck.saga);
  yield fork(addPhoto.saga);
  yield fork(selectionDuck.saga);
  yield fork(navigationDuck.saga);
  yield fork(preloaderDuck.saga);
  yield fork(sectionDuck.saga);
  yield fork(loadedImages.saga);
  yield fork(messages.saga);
  yield fork(pricing.saga);
  yield fork(marketingBannerDuck.saga);
  yield fork(appSyncSaga);

  //Background image uploading
  yield takeEvery(IMAGES_TO_UPLOAD, uploadImages);
}

export function* gallerySaga() {
  yield fork(addPhoto.saga);
  yield takeEvery(IMAGES_TO_UPLOAD, uploadImages);
}
